import React from "react";
import { Link, useLocation } from "react-router-dom";

import CraftHelpers from "../../helpers";
import { UserHelpers } from "components/user";
import { Icons } from "components/layout";
import CraftTypeLabel from "../../blocks/craft-type-label";
import { CUSTOM_CRAFT_TITLES_ENABLED, getCustomCraftTitles } from "../../helpers/craft-title-helper";


const { permission } = UserHelpers;

const CraftOverviewGridItem = ({ craftLabel, craftType, titles, counters }) => {

    const location = useLocation();
    const customTitles = CUSTOM_CRAFT_TITLES_ENABLED ? getCustomCraftTitles(
        craftType,
        titles,
        CraftHelpers.Types.localizeParams(craftType)
    ) : [];

    return(
        <div className="craft-overview-grid-item">
            <h3>
                <Icons.Craft
                    type={ /\d/.test(craftType) ? craftType.replace(/_\d/g, '') : craftType }
                />
                <span className="craft-overview-title">
                    <CraftTypeLabel
                        type={ craftType }
                        title={ craftLabel }
                    />
                    { customTitles.length > 0 &&
                        <>
                            { " (" }
                            { customTitles.map((title, index) => (
                                <React.Fragment key={ title }>
                                    { index > 0 && " / " }
                                    <CraftTypeLabel
                                        type={ craftType }
                                        title={ title }
                                        preferCustomTitle
                                    />
                                </React.Fragment>
                            )) }
                            { ")" }
                        </>
                    }
                </span>
            </h3>
            <div className="overview-statistic bg-light-bordered">
                { CraftHelpers.OverviewCountTypes.map(
                    ( { label, type, route, getFilter = () => {}, getColor = () => {} } ) => {

                    const Wrap = ({ children, className = "" }) => {

                        const routeExist = route.includes("jobs") ? permission().has({type: "craft_job", value: "view_job"}) : true;

                        if(counters[type] > 0 && route && routeExist){
                            return(
                                <Link
                                    className= { `overview-statistic-item ${ className }` }
                                    to={{
                                        pathname: route,
                                        state: {
                                            from : location.pathname,
                                            queryParams : getFilter({ craftType })
                                        }
                                    }}
                                >
                                    { children }
                                </Link>
                            )
                        }

                        return (
                            <div className = { `overview-statistic-item ${ className }` } >
                                { children }
                            </div>
                        )
                    }

                    return(
                        <Wrap
                            key       = { type }
                            className = { getColor( counters[type] ) }
                        >
                            <h4>{ counters[type] }</h4>
                            <p>{ label }</p>
                        </Wrap>
                    )
                }) }
            </div>

        </div>
    )
};

export default CraftOverviewGridItem;
